export default function swiper() {
  const ourJobSwiper = new Swiper('.collaborators-swiper.swiper', {
    modules: [Navigation, Pagination, EffectCoverflow, EffectFade],
    effect: 'coverflow',
    loop: true,
    centeredSlides: true,
    grabCursor: false,
    allowTouchMove: false,
    breakpoints: {
      480: {
        slidesPerView: 1,
        spaceBetween: 10,
        effect: 'fade',
      },
      1200: {
        effect: 'coverflow',
        slidesPerView: 3,
        spaceBetween: -420,
        coverflowEffect: {
          rotate: 0,
          stretch: -500,
          depth: 0,
          modifier: 2,
          slideShadows: false,
        },
      },
      1650: {
        effect: 'coverflow',
        slidesPerView: 3,
        spaceBetween: -330,
        coverflowEffect: {
          rotate: 0,
          stretch: -340,
          depth: 0,
          modifier: 2,
          slideShadows: false,
        },
      },
    },
    navigation: {
      nextEl: '.collaborators-swiper .swiper-button-next',
      prevEl: '.collaborators-swiper .swiper-button-prev',
    },
  })

  const seeMoreSwiper = new Swiper('.see-more-swiper.swiper', {
    modules: [Navigation, EffectFade, Pagination],
    loop: true,
    allowTouchMove: true,
    watchSlidesProgress: true,
    breakpoints: {
      480: {
        slidesPerView: 4,
        spaceBetween: 10,
      },
      884: {
        slidesPerView: 4,
        spaceBetween: 10,
      },
    },
    navigation: {
      nextEl: '.see-more .swiper-button-next',
      prevEl: '.see-more .swiper-button-prev',
    },
  })

  function initializeSwiper() {
    const moreSlidesSwiper = new Swiper('.more-slides-swiper.swiper', {
      modules: [Navigation, EffectFade],
      loop: true,
      allowTouchMove: true,
      centeredSlides: false,
      spaceBetween: 10,
      breakpoints: {
        680: {
          slidesPerView: 1,
        },
      },
      navigation: {
        nextEl: '.more-slides .swiper-button-next',
        prevEl: '.more-slides .swiper-button-prev',
      },
    })

    // const simulatorRecomandationSwiper = new Swiper('.simulator-recomandation-swiper.swiper', {
    //   modules: [Navigation, EffectFade],
    //   loop: true,
    //   allowTouchMove: true,
    //   centeredSlides: false,
    //   spaceBetween: 10,
    //   breakpoints: {
    //     680: {
    //       slidesPerView: 1,
    //     },
    //   },
    //   navigation: {
    //     nextEl: '.simulator-recomandation .swiper-button-next',
    //     prevEl: '.simulator-recomandation .swiper-button-prev',
    //   },
    // })

    return {
      moreSlidesSwiper,
      //   simulatorRecomandationSwiper,
    }
  }

  let moreSlideSwiper

  function checkWindowSize() {
    if (window.innerWidth <= 680) {
      if (!moreSlideSwiper) {
        moreSlideSwiper = initializeSwiper()
      }
    } else {
      if (moreSlideSwiper) {
        moreSlideSwiper.destroy(true, true)
        moreSlideSwiper = undefined
      }
    }
  }
  window.addEventListener('resize', checkWindowSize)
  checkWindowSize()

  const bannerInitialSwiper = new Swiper('.banner-initial .swiper', {
    autoHeight: true,
    modules: [Navigation, EffectFade, Pagination],
    watchSlidesProgress: true,
    direction: window.innerWidth >= 680 ? 'vertical' : 'horizontal', // Define a direção inicial baseada no tamanho da tela
    pagination: {
      el: '.banner-initial .swiper-pagination',
      dynamicBullets: true,
    },
    breakpoints: {
      480: {
        direction: 'horizontal',
        slidesPerView: 1,
        spaceBetween: 0,
      },
      680: {
        direction: 'vertical',
        slidesPerView: 1,
        spaceBetween: 0,
      },
    },
    navigation: {
      nextEl: '.banner-initial .swiper-button-next',
      prevEl: '.banner-initial .swiper-button-prev',
    },
    on: {
      resize: function() {
        this.changeDirection() // Adiciona um handler para mudar a direção ao redimensionar a janela
      },
    },
  })

  bannerInitialSwiper.changeDirection = function() {
    this.direction = window.innerWidth >= 680 ? 'vertical' : 'horizontal'
    this.update()
  }
}
